import { render, staticRenderFns } from "./AggPagoPorCargoComponent.vue?vue&type=template&id=fc820a26&"
import script from "./AggPagoPorCargoComponent.vue?vue&type=script&lang=js&"
export * from "./AggPagoPorCargoComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports